function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import STRtree from '../../index/strtree/STRtree';
import IsValidOp from './IsValidOp';
import PointLocation from '../../algorithm/PointLocation';
import ArrayList from '../../../../../java/util/ArrayList';
import Envelope from '../../geom/Envelope';
var IndexedNestedRingTester = /*#__PURE__*/function () {
  function IndexedNestedRingTester() {
    _classCallCheck(this, IndexedNestedRingTester);
    IndexedNestedRingTester.constructor_.apply(this, arguments);
  }
  return _createClass(IndexedNestedRingTester, [{
    key: "buildIndex",
    value: function buildIndex() {
      this._index = new STRtree();
      for (var i = 0; i < this._rings.size(); i++) {
        var ring = this._rings.get(i);
        var env = ring.getEnvelopeInternal();
        this._index.insert(env, ring);
      }
    }
  }, {
    key: "getNestedPoint",
    value: function getNestedPoint() {
      return this._nestedPt;
    }
  }, {
    key: "isNonNested",
    value: function isNonNested() {
      this.buildIndex();
      for (var i = 0; i < this._rings.size(); i++) {
        var innerRing = this._rings.get(i);
        var innerRingPts = innerRing.getCoordinates();
        var results = this._index.query(innerRing.getEnvelopeInternal());
        for (var j = 0; j < results.size(); j++) {
          var searchRing = results.get(j);
          var searchRingPts = searchRing.getCoordinates();
          if (innerRing === searchRing) continue;
          if (!innerRing.getEnvelopeInternal().intersects(searchRing.getEnvelopeInternal())) continue;
          var innerRingPt = IsValidOp.findPtNotNode(innerRingPts, searchRing, this._graph);
          if (innerRingPt === null) continue;
          var isInside = PointLocation.isInRing(innerRingPt, searchRingPts);
          if (isInside) {
            this._nestedPt = innerRingPt;
            return false;
          }
        }
      }
      return true;
    }
  }, {
    key: "add",
    value: function add(ring) {
      this._rings.add(ring);
      this._totalEnv.expandToInclude(ring.getEnvelopeInternal());
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return IndexedNestedRingTester;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
export { IndexedNestedRingTester as default };
IndexedNestedRingTester.constructor_ = function () {
  this._graph = null;
  this._rings = new ArrayList();
  this._totalEnv = new Envelope();
  this._index = null;
  this._nestedPt = null;
  var graph = arguments[0];
  this._graph = graph;
};